import { createContext, useEffect, useReducer, useState } from "react";
import { AuthReducer } from "../Reducer/AuthReducer.jsx";
import { toast } from "react-toastify";
import { encode, isEmpty } from "../Utils/utils.js";
import { GETWITHOUTJSON, GETWITHOUTVALIDATE, POST, POSTWITHOUTVALIDATE } from "../Network/snpaxios.jsx";
import { FAILED, INVALIDEMAILOTP, INVALIDSMSOTP, SUCCESS, USEREXIST, WEBSITE_SHOP_HASH } from "../Utils/constant.js";
import { useLocation, useNavigate } from "react-router-dom";

export const AuthContext = createContext();
export const AuthProivider = ({ children }) => {

  const initialAuthState = {
    user: localStorage.getItem("custName"),
    mobile: localStorage.getItem("custMob"),
    email: localStorage.getItem("custEmail"),
    address: [],
  };

  const [authState, authDispatch] = useReducer(AuthReducer, initialAuthState);
  const [loader, setLoader] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();


  const requestOtp = async (mobNo) => {
    if (!isEmpty(mobNo)) {
      try {
        const encodedShopHash = encode(WEBSITE_SHOP_HASH);
        const payLoad = await GETWITHOUTJSON(`cart/req-mobile-otp?mobNo=${mobNo}&shopHash=${encodedShopHash}`);
        if (payLoad !== null) {
          return payLoad;
        }
      } catch (err) {
        console.error(`requestOtp:${mobNo}`, err);
        return FAILED;
      }
    } else {
      toast.error("Please enter valid mobile number!");
      return FAILED;
    }
  }


  const authLogin = async (loginData) => {
    if (!isEmpty(loginData.email) && !isEmpty(loginData.password)) {
      try {
        setLoader(true);
        const data = {
          jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
            custEmail: loginData.email,
            token: encode(loginData.password),
          },
        };
        const payLoad = await POST("ext/cart/login", data);
        if (payLoad !== null) {
          localStorage.setItem("custName", payLoad.custName);
          localStorage.setItem("custEmail", payLoad.custEmail);
          localStorage.setItem("custMob", payLoad.custMob);
          authDispatch({ type: "setUser", payload: payLoad.custName });
          authDispatch({ type: "setMobile", payload: payLoad.custMob });
          authDispatch({ type: "setEmail", payload: payLoad.custEmail });

          toast.success("Login Successfully!");
          navigate(location?.state?.from?.pathname ? location?.state?.from?.pathname : "/");
        }
      } catch (err) {
        console.error("authLogin:", err);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please enter valid input!");
    }
  };

  const getShopCustomer = async (loginData) => {
    if (!isEmpty(loginData.mobile) && !isEmpty(loginData.otp)) {
      try {
        setLoader(true);
        const data = {
          jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
            custMob: loginData.mobile,
            otp: loginData.otp,
          },
        };
        const payLoad = await POST("cart/get-shop-customer", data);
        if (payLoad !== null) {
          localStorage.setItem("custName", payLoad.custName);
          localStorage.setItem("custEmail", payLoad.custEmail);
          localStorage.setItem("custMob", payLoad.custMob);
          authDispatch({ type: "setUser", payload: payLoad.custName });
          authDispatch({ type: "setMobile", payload: payLoad.custMob });
          authDispatch({ type: "setEmail", payload: payLoad.custEmail });
          toast.success("Login Successfully!");
          navigate(location?.state?.from?.pathname ? location?.state?.from?.pathname : "/");
        }
      } catch (err) {
        console.error("getShopCustomer:", err);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please enter valid otp!");
    }
  };

  useEffect(() => {
    const custMob = authState?.mobile ?? "";
    if (!isEmpty(custMob)) {
      getListAddress(custMob);
    }
  }, [authState?.mobile])

  const userSignup = async (userData, callback) => {
    if (!isEmpty(userData.mobile) && !isEmpty(userData.email) && !isEmpty(userData.user)) {
      try {
        setLoader(true);
        const data = {
          jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
            custMob: userData.mobile,
            custName: userData.user,
            custEmail: userData.email,
            password: encode(userData.password),
          },
        };
        const response = await POSTWITHOUTVALIDATE("cart/create-shop-customer", data);
        if (response !== null) {
          if (response.status === SUCCESS) {
            toast.success("Account registeration initiated successfully");
            callback && callback();
          } else if (response.status === USEREXIST) {
            toast.warn("This Email/Mobile is already available,Kindly login");
          } else {
            toast.error("Unknown error,Try after sometime");;
          }
        }
      } catch (err) {
        console.error("userSignup:", err);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please enter valid details!");
    }
  };

  const verifyMobEmailOtp = async (userData, mobileOtp, emailOtp, eCallback) => {
    if (!isEmpty(userData.mobile) && !isEmpty(userData.email) && !isEmpty(mobileOtp) && !isEmpty(emailOtp)) {
      try {
        setLoader(true);
        const data = {
          jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
            mob: userData.mobile,
            mobileOtp: mobileOtp,
            email: userData.email,
            emailOtp: emailOtp,
          },
        };
        const response = await POSTWITHOUTVALIDATE("cart/verify-shop-user-otp", data);
        if (response !== null) {
          if (response.status === SUCCESS) {
            toast.success("Account created successfully");
            localStorage.setItem("custName", userData.user);
            localStorage.setItem("custEmail", userData.email);
            localStorage.setItem("custMob", userData.mobile);
            authDispatch({ type: "setUser", payload: userData.user });
            authDispatch({ type: "setMobile", payload: userData.mobile });
            authDispatch({ type: "setEmail", payload: userData.email });
            navigate(location?.state?.from?.pathname ? location?.state?.from?.pathname : "/");
            eCallback && eCallback(false);
          } else if (response.status === INVALIDSMSOTP) {
            toast.error("Invalid mobile otp");
            eCallback && eCallback(true);
          } else if (response.status === INVALIDEMAILOTP) {
            toast.error("Invalid email otp");
            eCallback && eCallback(true);
          } else {
            toast.error("Unknown error,Try after sometime");;
          }
        }
      } catch (err) {
        console.error("verifyMobEmailOtp:", err);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please enter valid details!");
    }
  };

  const updateAddress = async (addressForm = {}, isAdd) => {
    if (!isEmpty(authState?.mobile)) {
      try {
        setLoader(true);
        const data = {
          jcJson: {
            shopHash: encode(WEBSITE_SHOP_HASH),
            custMob: authState.mobile,
            isAdd: isAdd,
            ...addressForm,
          },
        };
        const payLoad = await POST("ext/create-customer-address", data);
        if (payLoad !== null) {
          if (isAdd) {
            authDispatch({
              type: "setAddress",
              payload: { ...addressForm, id: payLoad.id || addressForm.id },
            });
            toast.success("Address updated successfully!");
          } else {
            authDispatch({ type: "removeAddress", payload: addressForm.id });
            toast.success("Address deleted successfully!");
          }
        }
      } catch (err) {
        console.error("updateAddress:", err);
        toast.error("Failed to update! Please try again.");
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Please login first");
    }
  };

  const getListAddress = async (custMob) => {
    try {
      if (isEmpty(custMob)) {
        console.error("Please login fast");
        return;
      }
      const encodedShopHash = encode(WEBSITE_SHOP_HASH);
      const response = await GETWITHOUTVALIDATE(`ext/cart/customer-address?shopHash=${encodedShopHash}&custMob=${custMob}`);
      if (response !== null) {
        if (response.status === SUCCESS) {
          const payload = response.jcJson;
          authDispatch({ type: "replaceAddress", payload: payload.data });
        } else {
          authDispatch({ type: "replaceAddress", payload: [] });
        }
      } else {
        console.error("getListAddress", "null response");
      }
    } catch (error) {
      console.error("getListAddress", error);
    }
  };


  return (
    <AuthContext.Provider
      value={{
        authState,
        authDispatch,
        requestOtp,
        authLogin,
        getShopCustomer,
        userSignup,
        loader,
        setLoader,
        updateAddress,
        verifyMobEmailOtp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
